import { Component, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-mandala-icons',
    templateUrl: './mandala-icons.component.html',
    styleUrls: ['./mandala-icons.component.scss'],
    standalone: false
})
export class MandalaIconsComponent {
  @Output() openSettings = new EventEmitter<void>();
}
